import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import VMSListContainer from '../containers/VMSListContainer';

import Accordion from '../../Accordion/Accordion';

const VMSComponent = (props) => {
  const { buildingId } = props;
  return (
    <Box my={buildingId ? '2rem' : 0}>
      <Accordion type="visitorSettings" />
      <VMSListContainer {...props} />
    </Box>
  );
};

VMSComponent.propTypes = {
  buildingId: PropTypes.string,
};

export default VMSComponent;
